export default {
    name: "SettingsAddUserModal",

    props: {
        is_open: {
            type: Boolean,
            default: false
        },
        is_saving: {
            type: Boolean,
            default: false
        },
        form_error: {
            type: String,
            default: ""
        },
        role_options: {
            type: Array,
            default: () => []
        },
        is_loading_roles: {
            type: Boolean,
            default: false
        }
    },

    emits: ["close", "submit"],

    data() {
        return ({
            user_form: this.get_empty_user_form()
        });
    },

    watch: {
        is_open(next_value) {
            this.set_modal_lock(next_value);

            if (next_value) {
                this.user_form = this.get_empty_user_form();
            }
        },

        role_options(next_options) {
            this.sync_role_options(next_options);
        }
    },

    beforeUnmount() {
        this.set_modal_lock(false);
    },

    methods: {
        set_modal_lock(is_locked) {
            document.body.classList.toggle("settings-modal-open", Boolean(is_locked));
        },

        get_empty_user_form() {
            return ({
                first_name: "",
                last_name: "",
                email: "",
                phone_number: "",
                role: this.role_options[0] || ""
            });
        },

        is_matching_role_option(role_option) {
            const current_role = this.user_form.role;

            if (!role_option) return false;

            return typeof role_option === "object"
                ? role_option.name === current_role || String(role_option.id) === current_role
                : role_option === current_role;
        },

        sync_role_options(next_options) {
            if (!this.has_role_options(next_options)) return;

            const role_handler = this.user_form?.role
                ? "sync_existing_role"
                : "set_default_role";
            this[String(role_handler)](next_options);
        },

        has_role_options(next_options) {
            return Array.isArray(next_options) && Boolean(next_options.length);
        },

        set_default_role(next_options) {
            this.user_form.role = next_options[0];
        },

        sync_existing_role(next_options) {
            if (typeof this.user_form.role !== "string") return;

            const match = next_options.find((role_option) => this.is_matching_role_option(role_option));
            this.set_matched_role(match);
        },

        set_matched_role(match) {
            if (match) {
                this.user_form.role = match;
            }
        },

        submit_form() {
            const payload = {
                ...this.user_form,
                username: this.user_form.email
            };
            this.$emit("submit", payload);
        }
    }
};
